import { render, staticRenderFns } from "./AboutWhaleio.vue?vue&type=template&id=2fbd70ae&"
import script from "./AboutWhaleio.vue?vue&type=script&lang=js&"
export * from "./AboutWhaleio.vue?vue&type=script&lang=js&"
import style0 from "./AboutWhaleio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports